/* shim_v2 */
/*
 * App-download CTA click tracking — consumer shim.
 *
 * Captures clicks on any element with [data-app-download-cta] (the App Store
 * badge/button and the QR image rendered by theme/snippets/app-store-link.liquid)
 * and publishes 'app_download_click' events carrying the campaign token
 * (nc-<channel>-<origin>[-<variant>]) as `app_surface`.
 *
 * Routes through theme/assets/cta-tracking-core.js for the shared chain
 * (consent gate, pointerdown/click/auxclick capture, dedupe, 3-sink publish)
 * per rules/canonical_centralization.md — NO new tracking path.
 *
 * theme.liquid MUST load cta-tracking-core.js BEFORE this file.
 *
 * The `app_surface` value is the element's data-app-download-cta attribute (the
 * campaign `ct` token). It flows extraPayload -> app_download_click event ->
 * the Customer Events pixel's app_download_click subscription -> the GA4
 * `app_surface` event-scoped dimension. See docs/_DOC_APP_LAUNCH_ATTRIBUTION.md.
 *
 * Dedupe key: the surface token + pathname (app CTAs aren't tied to products;
 * the surface token alone tells us which install affordance fired).
 */
(function () {
  'use strict';

  if (!window.NCCtaTracking) {
    if (window.console) console.warn('[app-download-tracking] cta-tracking-core.js not loaded; tracker disabled');
    return;
  }

  window.NCCtaTracking.install({
    attr:'data-app-download-cta',
    eventName:'app_download_click',
    idempotencyFlag:'__ncAppDownloadTrackingLoaded',
    logPrefix:'app-download-tracking',
    dedupeKeyFn: function (el) {
      return el.getAttribute('data-app-download-cta') + '|' + window.location.pathname;
    },
    extraPayload: function (el) {
      return { app_surface: el.getAttribute('data-app-download-cta') };
    },
  });
})();
